import React from 'react';

const TrendingUpdates = () => {
  const updates = [
    "ASCO Guidelines Update: Management of Brain Metastases (Nov 12)",
    "FDA Approval: New indication for pembrolizumab in NSCLC (Nov 10)",
    "Major Trial Results: Phase III LUMINA Trial in HR+ Breast Cancer (Nov 8)",
    "New Meta-Analysis: Immunotherapy timing in NSCLC (Nov 7)"
  ];
  
  return (
    <div className="bg-white rounded-lg shadow mb-6">
      <div className="p-4 border-b">
        <h2 className="text-xl font-medium">Trending in Your Specialty</h2>
      </div>
      
      <div className="p-3">
        <ul className="space-y-3">
          {updates.map((update, index) => (
            <li key={index} className="p-2 hover:bg-gray-50 rounded cursor-pointer">
              <div className="flex items-start">
                <span className="mr-2">•</span>
                <span>{update}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TrendingUpdates;